import { useQuery } from '@tanstack/react-query';

import { getLocale } from '../../util/locales/locales';
import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import { useUserLocale } from '../../util/locales/use-user-locale';

export const usePromotionalBanner = (id: string) => {
  const userLocale = useUserLocale();
  const locale = userLocale || getLocale();

  const { key, fetcher } = StaticContentApiService.getPromotionalBannerEntryFetcher(locale, `${id}_${userLocale?.country.toLowerCase()}`);

  return useQuery([key], fetcher, { enabled: !!userLocale });
};
